import { isTruthy } from 'utils/common'

const isLocalReCaptchaEnabled = (): boolean => {
  return isTruthy(process.env.REACT_APP_ENABLE_LOCAL_RECAPTCHA)
}

export default isLocalReCaptchaEnabled
